/**
 * Check if the provided var is empty
 *
 * @param {any} val
 *
 * @return {boolean}
 */
export var isEmpty = function isEmpty(val) {
  if (val === false || val === null || val === undefined || val === '' || val === 0 || Array.isArray(val) && val.length === 0 || typeof val === 'object' && Object.keys(val).length === 0) {
    return true;
  }
  return false;
};
export var isNotEmpty = function isNotEmpty(val) {
  return !isEmpty(val);
};

/**
 * Check if the provided var is an object
 *
 * @param {object} object
 *
 * @return {boolean}
 */
export var isObject = function isObject(object) {
  return typeof object === 'object' && object instanceof Object && !Array.isArray(object);
};

/**
 * Check if the provided var is an array
 *
 * @param {any} value
 *
 * @return {boolean}
 */
export var isArray = function isArray(value) {
  return Array.isArray(value);
};

/**
 * Check if the provided var is string
 *
 * @param {any} value
 *
 * @return {boolean}
 */
export var isString = function isString(value) {
  return typeof value === 'string';
};

/**
 * Check if the provided var is function
 *
 * @param {any} value
 *
 * @return {boolean}
 */
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

/**
 * Checks if provided var is valid number.
 *
 * @param {val} any
 *
 * @return {boolean}
 */
export var isNumber = function isNumber(val) {
  return /^\d+$/.test(val);
};